import { SiteUrls } from '@tableau/shared-urls';

import { Module } from '../Module';
import { IWorkbookRevision } from '../ServerApi/types/IContentRevision';
import { ServerService } from '../services/ServerService';
import { WindowLocationService } from '../../commonInfra/services/WindowLocationService';

export class PreviewWorkbookRevisionAction {

  public static $inject = ['ServerService'];

  constructor(
    private serverService: ServerService) { }

  public openPreview(revision: IWorkbookRevision) {
    const siteUrls = new SiteUrls({siteUrlName: this.serverService.sessionSiteUrlName(), queryString: window.location.search});
    WindowLocationService.open(siteUrls.workbookRevisionPreviewUrl(revision.revisionPath));
  }

}

Module.instance().service('PreviewWorkbookRevisionAction', PreviewWorkbookRevisionAction);
